import { Component, EventEmitter, Input, Output } from '@angular/core';
import { MatButton } from '@angular/material/button';
import { MatIcon } from '@angular/material/icon';

@Component({
    selector: 'kh-app-flat-button',
    templateUrl: './app-flat-button.component.html',
    styleUrls: ['./app-flat-button.component.scss'],
    host: {
        'class': 'mat-mdc-button-base' // built-in material button wrapper class, so Material's own layout rules apply to this wrapper. Not styling.
    },
    imports: [
        MatButton,
        MatIcon
    ]
})
export class AppFlatButtonComponent {
    @Output() clicked = new EventEmitter<any>();

    @Input() disabled = false;
    @Input() appearDisabled: boolean | undefined = false;
    //To allow the button to appear disabled, but still allow the click event to happen in order to show error messages
    @Input() visuallyDisabled: boolean = this.disabled;
    @Input() width: string | number = 'auto';
    @Input() height?: string | number = undefined;
    @Input() icon: string | null = null;
    @Input() iconRight: string | null = null;

    get computedWidth(): string {
        return isNaN(Number(this.width)) ? String(this.width) : `${this.width}px`;
    }

    get computedHeight(): string | undefined {
        if (this.height === undefined) {
            return undefined;
        }
        return isNaN(Number(this.height)) ? String(this.height) : `${this.height}px`;
    }

    get isDisabledInteractive(): boolean {
        return !this.disabled && Boolean(this.appearDisabled || this.visuallyDisabled);
    }

    get isVisuallyDisabled(): boolean {
        return this.disabled || Boolean(this.appearDisabled || this.visuallyDisabled);
    }

    click(event: any): void {
        if (this.disabled) {
            return;
        }
        this.clicked.emit(event);
    }
}
